<template>
  <div class="mb-5">
    <h5 class="mb-2">СОБЫТИЯ ПО ТОРГАМ</h5>
    <div v-if="loader">
      <v-progress-linear
          indeterminate
          color="green"
      ></v-progress-linear>
    </div>
    <div v-else>
      <div v-if="List.length">
        <div
            class="text-body-2 events__list"
            v-for="(item, idx) in List"
            :key="idx">
          <v-icon class="mr-3" size="30" color="#c69494"> mdi-circle-small </v-icon>
          {{ item.text }}
        </div>
      </div>
      <div v-else>Нет данных</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: 'EventsTrade',
  data() {
    return {
      loader: true,
      Payload: [],
      List: [],
      getInterval: null
    }
  },
  created() {
    this.getPayload()
    this.getInterval = setInterval(()=> {
      this.List = []
      this.getPayload()
    }, 45000 )
  },
  destroyed() {
    clearInterval(this.getInterval)
    this.getInterval = null
  },
  watch: {
    Payload(val) {
      if (val.length) this.Building()
    },
  },
  methods: {
    async getPayload() {
      try {
        const result = await axios('/get-events-trade', {
          method: 'POST',
          headers: {
            "Authorization": this.$store.getters.getToken
          }
        })
        if (result.status === 200 && result.data.length) {
          this.Payload = result.data
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.loader = false
      }
    },
    Building() {
      if (this.Payload.length) {
        for (const item of this.Payload) {
          if (item.start_date > Date.now() / 1000) {
            this.List.push(
                {
                  text:
                      `Торги №${item.id} ${item.product} назанчены сегодня на ${moment.unix(item.start_date).format('HH:mm')} `
                }
            )
          }
          if (item.start_date < Date.now() / 1000 && item.stop_date > Date.now() / 1000) {
            this.List.push(
                {
                  text:
                      `Идут торги №${item.id} ${item.product}`
                }
            )
          }
          if (item.stop_date < Date.now() / 1000) {
            this.List.push(
                {
                  text:
                      `Завершены торги №${item.id} ${item.product}`
                }
            )
          }
        }
      }
    }
  }
}
</script>
